/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { CieloMerchant } from '../../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'


type Props = {
    cieloMerchant: CieloMerchant
}

const UpdatedInCell: FC<Props> = ({ cieloMerchant }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {cieloMerchant?.updatedAt ? formatDateTime(cieloMerchant.updatedAt.toString()) : 'N/A'}
        </a>
    </div>
)

export { UpdatedInCell }
